export default __webpack_public_path__ + "static/media/03.3.d8810c0d.jpg";